import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'beige' | 'white';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#FAF7F2]',
    beige: 'bg-[#E8E0D5]',
    white: 'bg-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${bgColors[background]} ${className}`} data-id="element-167">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto" data-id="element-168">
        {children}
      </motion.div>
    </section>;
}